( function () {
	'use strict';

	/* @ngInject */
	function interceptor ( HEADERS, ERROR_MSGS, $location, $q, logger, Session, apiResponses, $window ) {
		var responseOverride = {};
		var emptyResponse    = {
			'getResponse' : angular.noop
		};

		function request ( headerConfig ) {
			// send custom headers
			headerConfig.headers[ 'x-engine-id' ]     = HEADERS[ 'x-engine-id' ];
			headerConfig.headers[ 'x-engine-secret' ] = HEADERS[ 'x-engine-secret' ];

			if ( Session.getCredentials() ) {
				headerConfig.headers.Authorization = 'Bearer ' + Session.getCredentials().sessionToken;
			}

			return headerConfig;
		}

		function registerResponseOverride ( key, data ) {
			responseOverride[ key ] = data;
		}

		function apiResponseWrapper ( location, rejection ) {
			var contentLicenseErr = ( responseOverride[ location ] || emptyResponse ).getResponse( rejection ) || apiResponses( rejection.status );

			if ( rejection.data === 'User does not have content licenses' ) {
				contentLicenseErr = {
					'title'   : rejection.data,
					'message' : ''
				};
			}

			return contentLicenseErr;
		}

		function requestError ( rejection ) {
			logger.error( ERROR_MSGS.authError, rejection );
			return $q.reject( rejection );
		}

		function constructErrorMessage ( error ) {
			var serverError = [
				'Observation Formula Calculation',
				'Observation Formula Missing Group',
				'Group Formula Calculation',
				'Group Formula Item Missing',
				'Group Missing Formula'
			];

			var clientError = [
				'Computation error.',
				'Missing item or section.',
				'Computation error.',
				'Missing item or section.',
				'Computation error.'
			];

			return '<b>Failed to Save</b><br/>' + error.data.map( function ( errorObj ) {
				return clientError[ serverError.indexOf( errorObj.type ) ];
			} ).join( '<br/>' );
		}

		function responseError ( rejection ) {
			var rejectionConfig = rejection.config || {};

			logger.error( ERROR_MSGS.authError, rejection );

			if ( apiResponses( rejection.status ).title !== void 0 && logger.notifyErrorCode && !rejectionConfig.customError ) {
				if ( rejection.status === 400 && Array.isArray( rejection.data ) ) {
					logger.notifyError( constructErrorMessage( rejection ) );
				} else if ( rejection.status === 400 && rejection.data === 'Not Found' && rejectionConfig.url.indexOf( '/api/v1/users/' + Session.getCredentials().PersonnelId + '/templates/' ) > -1 ) {
					logger.notifyError( 'Cannot load observation, template not found', 'Observation' );
				} else if ( rejection.status === 404 && rejectionConfig.url.indexOf( '/feedback' ) > -1 ) {
					logger.info( 'feedback activated' );
				} else if ( rejection.status === 403 && rejectionConfig.url.indexOf( '/api/v1/legacy/users/' ) > -1 ) {
					logger.notifyError( 'The content license associated with this account does not include this particular video. Please contact Support at 1-855-337-7500 for more information.' );
				} else if ( rejection.status === 404 && rejection.data === 'Not Found' && rejectionConfig.url.indexOf( '/privileges/observe/observations' ) > -1 ) {
					logger.info( 'Privilege not found' );
				} else if ( rejection.status === 404 && rejection.data === 'Not Found' && rejectionConfig.url.indexOf( '/files/resources' ) > -1 ) {
					logger.info( 'ResourceId not found' );
				} else {
					logger.notifyErrorCode( rejection.status, apiResponseWrapper( $location.path(), rejection ) );
				}
			}

			// execute custom rejection handler
			( rejectionConfig.customError || angular.noop )( rejection.status );

			// if session token expires
			if ( Session.getCredentials() && rejection.status === 401 ) {
				Session.destroyCredentials();
				Session.destroyFirstTime();
				Session.destroyUserPermissions();
				$window.location.reload();
			}

			return $q.reject( rejection );
		}

		var settings = {
			'request'       : request,
			'requestError'  : requestError,
			'responseError' : responseError,

			'registerResponseOverride' : registerResponseOverride
		};

		return settings;
	}

	angular
		.module( 'app.core' )
		.factory( 'tokenInterceptor', interceptor );
} )();
